module.exports = __webpack_public_path__ + "img/4.2.f4ae45a1.png";